import { MigrationExperimentMapping, SearchMigrationAdapter } from 'stores/adapters/bex-api/migration-adapters';
import { adaptSortAndFilters } from './sort-and-filter';

/**
 * Ex: adaptSearchResultsTitle
 *
 *  import { adaptSearchResultsTitle } from './search-results-title';
 *
 *  export const searchMigrationExperimentMapping: MigrationExperimentMapping = {
 *    example_experiment_name: adaptSearchResultsTitle
 *  };
 */

// Key/value pairs of experiment names and their associated adapters.
export const searchMigrationExperimentMapping: MigrationExperimentMapping = {
  shopping_pwa_mm_bex_api_lodging_sort_and_filter: adaptSortAndFilters
};

// Adapters here to stay. Taken out of `searchMigrationExperimentMapping` and put in this list,
// after parity has been established in testing.
export const searchMigrationAdapters: SearchMigrationAdapter[] = [];
